<!-- Empty / baseline state: SENSE vision+hearing check not taken for this scan -->
<div *ngIf="!vm.available" class="card" style="margin-bottom:12px;padding:20px 18px;text-align:center;">
  <div style="font-size:15px;font-weight:800;color:var(--navy);margin-bottom:8px;">{{ 'results.se.empty.title' | translate }}</div>
  <p style="font-size:12.5px;color:var(--g500);line-height:1.6;margin:0 0 14px;">{{ 'results.se.empty.body' | translate }}</p>
  <button type="button" (click)="startCheck.emit()" style="display:inline-flex;align-items:center;justify-content:center;padding:11px 22px;background:var(--brand-fill-safe, var(--brand-color,#d1409c));color:#fff;border:none;border-radius:12px;font-size:14px;font-weight:600;cursor:pointer;font-family:inherit;line-height:1;">{{ 'results.se.empty.cta' | translate }}</button>
</div>

<ng-container *ngIf="vm.available">
  <div class="card" style="margin-bottom:12px;padding:16px 18px 14px;">
    <div style="display:flex;align-items:baseline;gap:7px;margin-bottom:12px;">
      <div style="font-size:15px;font-weight:800;color:var(--navy);letter-spacing:-0.2px;">{{ 'results.se.title' | translate }}</div>
      <div dir="ltr" style="font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:var(--g400);">SENSE™</div>
    </div>

    <!-- FIRST SCAN = the main screen (handoff 03 sec B): no number, no gauge, no label -->
    <ng-container *ngIf="vm.firstScan">
      <div style="font-size:17px;font-weight:800;color:var(--navy);line-height:1.35;">{{ 'results.se.startPoint' | translate }}</div>
      <div style="width:34px;height:3px;background:var(--brand-color,#d1409c);border-radius:2px;margin:9px 0 11px;"></div>
      <p style="font-size:13px;color:var(--g600);line-height:1.6;margin:0 0 16px;">{{ 'results.se.firstScanCompare' | translate }}</p>
      <div style="display:flex;flex-direction:column;gap:10px;margin-bottom:16px;">
        <div *ngFor="let r of vm.rows" style="display:flex;justify-content:space-between;align-items:center;gap:12px;">
          <span style="font-size:14px;font-weight:600;color:var(--navy);">{{ r.labelKey | translate }}</span>
          <span style="font-size:13px;font-weight:600;color:var(--g500);">{{ ('results.se.state.' + (r.state === 'notMeasured' ? 'notMeasured' : 'saved')) | translate }}</span>
        </div>
      </div>
      <!-- returning sense-1.x user's first sense-2.0 scan: don't drop this silently (handoff 02 sec ו) -->
      <div *ngIf="vm.engineChanged" style="font-size:11.5px;color:var(--g500);line-height:1.5;margin-bottom:12px;">{{ 'results.se.engineChanged' | translate }}</div>
    </ng-container>

    <!-- SECOND SCAN ONWARD (handoff 03 sec C): per-metric change vs her own previous measured scan -->
    <ng-container *ngIf="!vm.firstScan">
      <div style="display:flex;flex-direction:column;gap:13px;margin-bottom:14px;">
        <div *ngFor="let r of vm.rows">
          <div style="display:flex;justify-content:space-between;align-items:baseline;gap:12px;">
            <span style="font-size:14px;font-weight:600;color:var(--navy);">{{ r.labelKey | translate }}</span>
            <span style="font-size:13px;font-weight:600;color:var(--g600);text-align:end;line-height:1.4;" [ngSwitch]="r.state">
              <ng-container *ngSwitchCase="'changed'">{{ r.dirKey | translate }}</ng-container>
              <ng-container *ngSwitchCase="'stable'">{{ 'results.se.state.stable' | translate }}</ng-container>
              <ng-container *ngSwitchCase="'notThisTime'">{{ 'results.se.state.notThisTime' | translate }}</ng-container>
              <ng-container *ngSwitchDefault>{{ 'results.se.state.saved' | translate }}</ng-container>
            </span>
          </div>
          <div *ngIf="r.state === 'changed' && r.sinceDate" style="font-size:11px;color:var(--g400);margin-top:3px;text-align:end;">{{ 'results.se.since' | translate: { date: r.sinceDate } }}</div>
        </div>
      </div>
      <div *ngIf="vm.engineChanged" style="font-size:11.5px;color:var(--g500);line-height:1.5;margin-bottom:12px;">{{ 'results.se.engineChanged' | translate }}</div>
    </ng-container>

    <div style="font-size:11px;color:var(--g500);line-height:1.55;">{{ 'results.se.disclaimer' | translate }}</div>
  </div>

  <!-- TREND OVER TIME: two separate series, no norm/band/average, gaps not bridged -->
  <div class="card" *ngIf="!vm.firstScan" style="margin-bottom:12px;padding:16px 18px;">
    <div style="font-size:13px;font-weight:700;color:var(--navy);margin-bottom:2px;">{{ 'results.se.trendTitle' | translate }}</div>
    <ng-container *ngIf="vm.hasGraph; else notEnough">
      <ng-container *ngFor="let s of [vm.vision, vm.hearing]">
        <div *ngIf="s.chart.has" style="margin-top:12px;" dir="ltr">
          <div style="font-size:11px;font-weight:600;color:var(--g400);margin-bottom:4px;text-transform:uppercase;letter-spacing:0.05em;">{{ s.labelKey | translate }}</div>
          <svg [attr.viewBox]="'0 0 ' + chartW + ' ' + chartH" preserveAspectRatio="xMidYMid meet" style="overflow:visible;display:block;width:100%;max-width:360px;height:auto;">
            <polyline *ngFor="let seg of s.chart.segments" [attr.points]="pts(seg)" fill="none" stroke="var(--brand-dark,#b22e80)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline>
            <circle *ngFor="let d of s.chart.dots" [attr.cx]="d.x" [attr.cy]="d.y" r="3" fill="var(--brand-dark,#b22e80)"></circle>
          </svg>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #notEnough>
      <p style="font-size:12.5px;color:var(--g500);line-height:1.55;margin:8px 0 0;">{{ 'results.se.trendNotEnough' | translate }}</p>
    </ng-template>
  </div>

  <!-- PER-METRIC DETAIL (opened on purpose only): what it measures + disclaimer + raw value -->
  <details class="ia-deep" *ngFor="let r of vm.rows">
    <summary class="ia-deep-toggle">
      <div>
        <div>{{ r.detailTitleKey | translate }}</div>
        <div style="font-size:11px;font-weight:500;color:var(--g400);margin-top:2px;">{{ 'results.se.detailToggle' | translate }}</div>
      </div>
      <svg class="ia-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg>
    </summary>
    <div class="card" style="margin-top:10px;padding:14px 16px;">
      <div style="font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;color:var(--g400);margin-bottom:4px;">{{ 'results.se.whatItMeasures' | translate }}</div>
      <p style="font-size:13px;color:var(--g600);line-height:1.6;margin:0 0 12px;">{{ r.whatKey | translate }}</p>
      <div *ngIf="r.rawValue" dir="ltr" style="font-size:12px;color:var(--g500);text-align:start;"><span style="text-transform:uppercase;letter-spacing:0.04em;color:var(--g400);">{{ 'results.se.rawLabel' | translate }}:</span> {{ r.rawValue }}</div>
      <p style="font-size:11px;color:var(--g400);line-height:1.55;margin:10px 0 0;">{{ 'results.se.detailDisclaimer' | translate }}</p>
    </div>
  </details>

  <!-- KEEP IN MIND -->
  <div class="warm-message-sage warm-message" style="margin-top:12px;" [attr.data-label]="'results.se.keepLabel' | translate">
    {{ 'results.se.keepBody' | translate }}
  </div>

  <!-- TOOLS WE OFFER -->
  <app-tools-recommendation domain="sense"></app-tools-recommendation>
</ng-container>
